import { createContext, useContext } from 'react';
export function defineFrontendModule(module) {
    return module;
}
export const ModuleApiContext = createContext(null);
export function useModuleApi() {
    const api = useContext(ModuleApiContext);
    if (api === null) {
        throw new Error('ModuleApiContext fehlt — die Shell muss ihn um die Modul-Routen legen.');
    }
    return api;
}
//# sourceMappingURL=web.js.map